import { FEATURE_LABELS } from '../../domain/labels';

export const HELIX_TITLES: Record<string, string> = {
  'moderation.banUser': 'Bannir un utilisateur',
  'moderation.unbanUser': 'Débannir un utilisateur',
  'moderation.warnUser': 'Avertir un utilisateur',
  'chat.deleteMessage': 'Supprimer un message',
  'chat.sendMessage': 'Envoyer un message',
  'chat.sendAnnouncement': 'Envoyer une annonce',
  'chat.sendShoutout': 'Envoyer un shoutout',
  'chat.updateSettings': 'Modifier les réglages du chat',
  'channels.modifyInformation': 'Modifier les informations de la chaîne',
  'channels.postChannelsCommercial': 'Lancer une publicité',
  'channels.postChannelsAdsScheduleSnooze': 'Reporter la prochaine publicité',
  'raids.start': 'Lancer un raid',
  'raids.cancel': 'Annuler le raid',
  'polls.createPoll': 'Créer un sondage',
  'polls.endPoll': 'Terminer le sondage',
  'predictions.createPrediction': 'Créer un pronostic',
  'predictions.endPrediction': 'Terminer le pronostic',
  'channelPoints.createReward': 'Créer une récompense',
  'channelPoints.updateReward': 'Modifier une récompense',
  'channelPoints.deleteReward': 'Supprimer une récompense',
  'channelPoints.updateRedemption': 'Mettre à jour un échange',
  'streams.postStreamsMarkers': 'Poser un marqueur',
  'channels.postChannelsVips': 'Ajouter un VIP',
  'channels.deleteChannelsVips': 'Retirer un VIP',
  'moderation.postModerationModerators': 'Ajouter un modérateur',
};

export { FEATURE_LABELS };

export function helixTitle(endpoint: string): string {
  return HELIX_TITLES[endpoint] ?? endpoint;
}
